export function getToken() {

    var token = window.localStorage.getItem('id_token');

    return token;
}

export function setToken(token) {
    return dispatch => {
        window.localStorage.setItem('id_token', token);
    };
}

export function tokenExists() {
    return (getToken() ? true : false);
}

export function clearToken() {
    window.localStorage.removeItem('id_token');
}


// WEBPACK FOOTER //
// ./src/utils/tokenUtil.js